import React from 'react';

interface ListItem {
    title: string;
    content: () => JSX.Element;
    icon?: string;
}
export const listCollapseOutstaff: Record<string, ListItem[]> = {
    outstaff: [
        {
            title: 'Что представляет собой аутстаф в IT?',
            content: () => (
                <p>
                    IT-аутстаффинг — это модель найма, при которой компания передает часть своих
                    IT-задач и функций другим специализированным фирмам или исполнителям. Вместо
                    того, чтобы содержать свое собственное IT-подразделение, организация нанимает
                    внешних специалистов для решения своих IT-задач. Это позволяет компании
                    сосредоточиться на своих основных задачах, а заботу об IT-вопросах переложить на
                    экспертов из другой компании.
                </p>
            ),
        },
        {
            title: 'Каких наших специалистов можно привлечь к работе посредством аутстаффинга?',
            content: () => (
                <p>
                    Наша команда специалистов охватывает все ключевые роли в области IT: UX/UI
                    дизайнеры, аналитики, devops, backend-разработчики, frontend-разработчики,
                    QA-инженеры. Среди них специалисты разного грейда: джуниоры, мидлы, сеньоры.
                    Каждый из наших сотрудников участвовал в разработке нескольких проектов в
                    различных сферах, поэтому мы можем быстро найти подходящего специалиста для
                    любой задачи.
                </p>
            ),
        },
        {
            title: 'Чем аутстаф отличается от аутсорса?',
            content: () => (
                <p>
                    Аутсорсинг — это передача задач для выполнения другим компаниям. Аутстаффинг —
                    это найм специалистов для выполнения задач внутри вашей компании. Вы можете
                    нанимать опытных специалистов и управлять их деятельностью. По сути, это аренда
                    разработчиков для вашей компании.
                </p>
            ),
        },
        {
            title: 'Как оценить эффективность аутстафа?',
            content: () => (
                <>
                    <p>
                        Эффективность аутстаф разработчиков можно оценить по нескольким критериям:
                    </p>
                    <ul>
                        <li>Своевременное выполнение задач.</li>
                        <li>Качество кода и разработанных продуктов.</li>
                        <li>Соответствие результатов ожиданиям и требованиям.</li>
                        <li>Эффективность использования ресурсов (времени, бюджета).</li>
                    </ul>
                    <p>
                        Эти критерии можно оценить через мониторинг выполнения задач, проверку кода,
                        обратную связь от команды и пользователей, а также анализ результатов
                        проектов.
                    </p>
                </>
            ),
        },
        {
            title: 'Для кого полезен аутстаффинг?',
            content: () => (
                <p>
                    Аутстаффинг пригодится всем компаниям, независимо от их размера. Он позволяет
                    быстро заменить ушедших сотрудников, масштабировать проекты и разгрузить
                    внутреннюю команду.
                </p>
            ),
        },
    ],
    backend: [
        {
            title: 'Чем отличается аутстаффинг PHP разработчиков от аутсорсинга проектов?',
            content: () => (
                <p>
                    Аутстаффинг PHP разработчиков предполагает найм специалистов для работы внутри
                    компании заказчика. В отличие от этого, аутсорсинг проектов означает передачу
                    конкретных проектных задач или всего проекта другой компании на выполнение без
                    постоянного наличия специалистов внутри компании.
                </p>
            ),
        },
        {
            title: 'Как нанять через аутстаф РНР разработчиков?',
            content: () => (
                <p>
                    Определите требования: какой набор навыков и опыта необходим для вашего проекта.
                    Проведите собеседование — для этого оставьте заявку на аутстаф php на сайте. В
                    ней напишите несколько слов о вашей задаче и укажите свои контактные данные для
                    связи. Затем мы заключим договор с описанием условий работы, сроками и оплатой.
                </p>
            ),
        },
        {
            title: 'На какой срок можно нанять разработчика?',
            content: () => (
                <p>
                    Сроки найма php разработчика через аутстаффинг могут быть различными и зависят
                    от потребностей вашего проекта. Мы предлагаем гибкие условия и можем
                    предоставить специалистов как на краткосрочные проекты, так и на длительное
                    сотрудничество, включая полный рабочий день или определенное количество часов в
                    неделю.
                </p>
            ),
        },
        {
            title: 'Какие навыки и опыт должны быть у PHP разработчика при аутстаффинге?',
            content: () => (
                <>
                    <p>Важными навыками являются:</p>
                    <ul>
                        <li>
                            Знание языка программирования PHP и его фреймворков (1C-Битрикс,
                            Laravel, Symfony)
                        </li>
                        <li>Опыт работы с базами данных, такими как MySQL или PostgreSQL</li>
                        <li>Опыт работы с системами контроля версий, такими как Git.</li>
                        <li>Умение эффективно коммуницировать и работать в команде.</li>
                        <li>Понимание принципов безопасности веб-приложений.</li>
                        <li>Умение оптимизировать производительность веб-приложений.</li>
                    </ul>
                </>
            ),
        },
    ],
    frontend: [
        {
            title: 'Что такое аутстаффинг Frontend разработчиков и как это работает?',
            content: () => (
                <p>
                    Аутстаффинг frontend разработчиков — это процесс найма специалистов по
                    разработке пользовательского интерфейса (UI) и клиентской части веб-приложений
                    или сайтов для работы внутри вашей компании. Разработчик принимает участие в
                    разработке пользовательского интерфейса, создании и поддержке веб-страниц и
                    компонентов, взаимодействует с backend-разработчиками и дизайнерами для создания
                    полноценного веб-приложения или сайта.
                </p>
            ),
        },
        {
            title: 'Какие преимущества аутстаффинга Frontend разработчиков перед наймом в штат?',
            content: () => (
                <p>
                    Аутстаффинг позволяет сократить затраты на зарплаты, налоги, обучение и другие
                    расходы, связанные с наймом сотрудников. Вы платите только за фактически
                    отработанное время или объем выполненной работы. Также временный найм позволяет
                    избежать необходимости поддерживать постоянный штат сотрудников вне зависимости
                    от объема работы. Плюсом является и то, что через аутстаффинг вы можете быстро
                    найти и привлечь к работе опытных frontend разработчиков с нужными навыками и
                    опытом, что позволяет быстрее запустить проект или усилить команду.
                </p>
            ),
        },
        {
            title: 'Как мы поддерживаем качество работы Frontend разработчика?',
            content: () => (
                <p>
                    Мы уделяем много внимания кругозору и развитию команды. У нас налажены
                    индивидуальные траектории развития, на постоянной основе проходят внутренние
                    митапы, а также делается упор на развитие профессионального сообщества. Нашим
                    разработчиком нужно подтвердить десятки компетенций, прежде чем они смогут
                    работать с вашими проектами.
                </p>
            ),
        },
        {
            title: 'Как работать с Frontend разработчиком на аутстафе?',
            content: () => (
                <p>
                    Обсудите требования к проекту и ожидания от разработчика. Уточните технологии,
                    которые предпочтительны для использования, а также функциональность, которую
                    нужно реализовать. Установите сроки выполнения задач, обеспечьте сотрудника
                    необходимыми ресурсами для работы, отслеживайте прогресс работы и предоставляйте
                    обратную связь.
                </p>
            ),
        },
        {
            title: 'Кто будет контролировать работу Frontend программиста на аутстафе?',
            content: () => (
                <p>
                    Контроль за работой frontend разработчика на аутстафе обычно осуществляется
                    менеджером или тимлидом вашей компании, который непосредственно связан с
                    проектом.
                </p>
            ),
        },
    ],
    qa: [
        {
            title: 'В чем разница между QA и тестировщиком?',
            content: () => (
                <p>
                    QA-инженеры занимаются обеспечением качества продукта на всех этапах разработки,
                    включая планирование и улучшение процессов, в то время как тестировщики
                    фокусируются на выполнении конкретных тестовых задач и проверке функциональности
                    продукта.
                </p>
            ),
        },
        {
            title: 'Какие критерии важны при выборе аутстаф QA специалиста для проекта?',
            content: () => (
                <>
                    <p>При выборе аутстаф QA специалиста для проекта важно учитывать:</p>
                    <ul>
                        <li>
                            Опыт и знания специалиста в области тестирования, включая знание
                            методологий и инструментов тестирования, а также процессов разработки.
                        </li>
                        <li>
                            Навыки: специалист должен владеть основными видами тестирования, такими
                            как ручное, нагрузочное и автоматизированное.
                        </li>
                        <li>
                            Внимательность: QA специалист должен быть внимателен к деталям, чтобы
                            обеспечить полное покрытие функциональности и выявить все потенциальные
                            проблемы.
                        </li>
                    </ul>
                </>
            ),
        },
        {
            title: 'В чем заключается работа QA на аутстафе?',
            content: () => (
                <p>
                    Работа QA специалиста на аутстафе направлена на обеспечение высокого уровня
                    качества продукта и удовлетворения требований заказчика. QA участвует в
                    планировании процесса тестирования, определяет стратегии и методы тестирования в
                    соответствии с требованиями проекта. Разрабатывает тестовые случаи и сценарии,
                    которые будут использоваться для проверки функциональности продукта. Проводит
                    тестирование, регистрирует ошибки и предоставляет отчеты о состоянии качества
                    продукта.
                </p>
            ),
        },
        {
            title: 'Как обеспечить эффективное взаимодействие с аутстаф QA-командой?',
            content: () => (
                <p>
                    Предоставьте четкую и подробную информацию о требованиях к продукту,
                    функциональности, ожиданиях по качеству и срокам. Обеспечьте доступ ко всем
                    необходимым для работы ресурсам, предоставляйте обратную связь по результатам
                    тестирования. Соблюдение этих практик поможет обеспечить эффективное
                    взаимодействие с аутстаф QA специалистом.
                </p>
            ),
        },
    ],
    promotion: [
        {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            icon: '/images/svg/promotion/1.svg',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            title: 'Разработка стратегии продвижения',
            content: () => (
                <p>
                    Разработка стратегии начинается с&nbsp;анализа конкурентов и&nbsp;целевой
                    аудитории. Определяются ключевые запросы, разрабатываются тактики улучшения
                    видимости сайта, устанавливаются цели и&nbsp;KPI. Стратегия продвижения
                    формируется на&nbsp;основе детального анализа рынка и&nbsp;особенностей бизнеса.
                </p>
            ),
        },
        {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            icon: '/images/svg/promotion/2.svg',
            // eslint-disable-next-line sonarjs/no-duplicate-string
            title: 'Настройка систем аналитики',
            content: () => (
                <p>
                    Системы аналитики позволяют отслеживать поведение пользователей на&nbsp;сайте
                    и&nbsp;оценивать эффективность SEO продвижения. Устанавливаются
                    и&nbsp;настраиваются инструменты Google Analytics, Яндекс.Метрика и&nbsp;другие
                    системы аналитики для мониторинга трафика и&nbsp;пользовательских действий.
                </p>
            ),
        },
        {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            icon: '/images/svg/promotion/3.svg',
            title: 'Составление технического задания и&nbsp;написание текстов',
            content: () => (
                <p>
                    Аутсорсинг — это передача задач для выполнения другим компаниям. Аутстаффинг —
                    это найм специалистов для выполнения задач внутри вашей компании. Вы можете
                    нанимать опытных специалистов и управлять их деятельностью. По сути, это аренда
                    разработчиков для вашей компании.
                </p>
            ),
        },
        {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            icon: '/images/svg/promotion/4.svg',
            title: 'Верстка и&nbsp;программирование',
            content: () => (
                <>
                    <p>
                        Эффективность аутстаф разработчиков можно оценить по нескольким критериям:
                    </p>
                    <ul>
                        <li>Своевременное выполнение задач.</li>
                        <li>Качество кода и разработанных продуктов.</li>
                        <li>Соответствие результатов ожиданиям и требованиям.</li>
                        <li>Эффективность использования ресурсов (времени, бюджета).</li>
                    </ul>
                    <p>
                        Эти критерии можно оценить через мониторинг выполнения задач, проверку кода,
                        обратную связь от команды и пользователей, а также анализ результатов
                        проектов.
                    </p>
                </>
            ),
        },
        {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            icon: '/images/svg/promotion/1.svg',
            title: 'Ссылочная масса и&nbsp;репутация',
            content: () => (
                <p>
                    Аутстаффинг пригодится всем компаниям, независимо от их размера. Он позволяет
                    быстро заменить ушедших сотрудников, масштабировать проекты и разгрузить
                    внутреннюю команду.
                </p>
            ),
        },
        {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            icon: '/images/svg/promotion/5.svg',
            title: 'Контроль и&nbsp;улучшение сайта',
            content: () => (
                <p>
                    Аутстаффинг пригодится всем компаниям, независимо от их размера. Он позволяет
                    быстро заменить ушедших сотрудников, масштабировать проекты и разгрузить
                    внутреннюю команду.
                </p>
            ),
        },
    ],
    outstaffSolution: [
        {
            title: 'Какие факторы влияют на успешное SEO-продвижение медицинского сайта?',
            content: () => (
                <p>
                    Успешное СЕО-продвижение сайта медицинской клиники зависит от&nbsp;качественного
                    контента, соответствующего E-A-T (экспертиза, авторитетность, надёжность),
                    оптимизации ключевых слов, адаптированности под мобильные устройства, скорости
                    загрузки страниц и&nbsp;наличия отзывов пациентов.
                </p>
            ),
        },
        {
            title: 'Как отслеживать результаты продвижения?',
            content: () => (
                <p>
                    Чтобы отследить результаты SEO-продвижения, используйте специальные инструменты
                    для проведения аналитики, к&nbsp;примеру, Яндекс.Метрику и&nbsp;Google Search
                    Console. С&nbsp;их&nbsp;помощью можно отслеживать органический трафик,
                    поведенческие метрики (период проведенного времени на&nbsp;сайте, количество
                    отказов) и&nbsp;конверсии сайта.
                </p>
            ),
        },
        {
            title: 'Какая информация должна быть на медицинском сайте, чтобы он успешно продвигался?',
            content: () => (
                <p>
                    На&nbsp;медицинском сайте должны быть разделы с&nbsp;услугами, профилями врачей,
                    контактной информацией, блогом с&nbsp;полезными статьями, отзывами пациентов
                    и&nbsp;часто задаваемыми вопросами. Важно, чтобы контент был актуальным,
                    достоверным и&nbsp;оптимизированным под ключевые запросы.
                </p>
            ),
        },
        {
            title: 'При продвижении моего сайта, кто будет писать тексты?',
            content: () => (
                <p>
                    При продвижении медицинского сайта тексты пишут профессиональные копирайтеры
                    с&nbsp;медицинским образованием или опытом работы в&nbsp;сфере здравоохранения.
                    Это гарантирует точность и&nbsp;соответствие требованиям E-A-T.
                </p>
            ),
        },
        {
            title: 'Сколько времени требуется для достижения ощутимых результатов продвижения медицинского сайта?',
            content: () => (
                <p>
                    Время, необходимое для достижения ощутимых результатов, может варьироваться
                    в&nbsp;зависимости от&nbsp;текущего состояния сайта, конкуренции
                    в&nbsp;медицинской нише и&nbsp;объема выполненных работ. В&nbsp;среднем, первые
                    результаты можно заметить через 3-6&nbsp;месяцев, но&nbsp;для устойчивого роста
                    и&nbsp;значительных улучшений может потребоваться 6-12 месяцев регулярной
                    работы.
                </p>
            ),
        },
    ],
    banki: [
        {
            icon: '/images/svg/promotion/1.svg',
            title: 'Разработка стратегии продвижения',
            content: () => (
                <p>
                    Разработка стратегии начинается с&nbsp;анализа конкурентов и&nbsp;целевой
                    аудитории. Определяются ключевые запросы, разрабатываются тактики улучшения
                    видимости сайта, устанавливаются цели и&nbsp;KPI. Стратегия продвижения
                    формируется на&nbsp;основе детального анализа рынка и&nbsp;особенностей бизнеса.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/2.svg',
            title: 'Настройка систем аналитики',
            content: () => (
                <p>
                    Системы аналитики позволяют отслеживать поведение пользователей на&nbsp;сайте
                    и&nbsp;оценивать эффективность SEO продвижения. Устанавливаются
                    и&nbsp;настраиваются инструменты Google Analytics, Яндекс.Метрика и&nbsp;другие
                    системы аналитики для мониторинга трафика и&nbsp;пользовательских действий.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/3.svg',
            title: 'Сбор семантических запросов',
            content: () => (
                <p>
                    Сбор запросов включает анализ и&nbsp;подбор ключевых слов, которые наиболее
                    релевантны для продвигаемого сайта. При подборе формируется семантическое ядро,
                    которое служит основой для дальнейшей оптимизации контента и&nbsp;расширения
                    структуры сайта, улучшения его видимости в&nbsp;поисковых системах.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/4.svg',
            title: 'Технический аудит сайта',
            content: () => (
                <p>
                    Аудит сайта проводится для выявления ошибок и&nbsp;проблем, которые препятствуют
                    эффективному SEO продвижению. Проверяются скорость загрузки сайта, мобильная
                    адаптация, правильность индексации, наличие дублирующегося контента и&nbsp;иные
                    технические моменты. Результаты аудита используются для устранения ошибок.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/1.svg',
            title: 'Формирование и&nbsp;расширение структуры сайта',
            content: () => (
                <p>
                    Данный вид работ направлен на&nbsp;создание удобной и&nbsp;логичной иерархии
                    страниц. Оптимизируется архитектура сайта, создаются новые разделы
                    и&nbsp;страницы, улучшается внутреннее перелинкование. Это помогает
                    пользователям ориентироваться на&nbsp;сайте, а&nbsp;поисковым системам легче
                    находить и&nbsp;индексировать контент.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/5.svg',
            title: 'Оптимизация контента',
            content: () => (
                <p>
                    Включает редактирование контента на&nbsp;существующих страницах и&nbsp;создание
                    нового с&nbsp;учётом семантического ядра. Важно обеспечить уникальность,
                    информативность и&nbsp;релевантность контента для пользователей и&nbsp;поисковых
                    систем. Оптимизируются заголовки, мета теги, изображения и&nbsp;иные элементы.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/1.svg',
            title: 'Проработка внешней ссылочной массы',
            content: () => (
                <p>
                    Направлена на&nbsp;увеличение числа качественных внешних ссылок на&nbsp;сайт.
                    Проводится работа по&nbsp;размещению ссылок на&nbsp;авторитетных ресурсах,
                    а&nbsp;также создание контента, которым пользователи будут сами активно
                    делиться. Это улучшает авторитет и&nbsp;позиции сайта в&nbsp;поисковой выдаче.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/2.svg',
            title: 'Мониторинг и аналитика',
            content: () => (
                <p>
                    Это непрерывный процесс отслеживания показателей сайта и&nbsp;анализа
                    эффективности SEO мероприятий. Регулярно анализируются данные о&nbsp;трафике,
                    поведении пользователей, позициях в&nbsp;поисковых системах. На&nbsp;основе этой
                    информации корректируется стратегия продвижения.
                </p>
            ),
        },
    ],
    bankiQuestions: [
        {
            title: 'Что включает в себя SEO-стратегия для сайтов банков?',
            content: () => (
                <p>
                    SEO-стратегия для банковских сайтов включает исследование ключевых слов,
                    оптимизацию контента, улучшение технической части сайта (скорость загрузки,
                    мобильная версия), работу над внешними ссылками, локальное SEO, а&nbsp;также
                    постоянный анализ и&nbsp;корректировку стратегии на&nbsp;основе данных
                    аналитики.
                </p>
            ),
        },
        {
            title: 'Как долго нужно продвигать банковский сайт?\n',
            content: () => (
                <p>
                    Продвижение банковского сайта&nbsp;&mdash; это долгосрочный процесс. Первые
                    результаты могут появиться через 3-6 месяцев активной работы, однако для
                    достижения устойчивых позиций и&nbsp;высоких показателей трафика потребуется
                    от&nbsp;12&nbsp;до&nbsp;18&nbsp;месяцев непрерывной оптимизации
                    и&nbsp;поддержки.
                </p>
            ),
        },
        {
            title: 'Какие особенности продвижения сайта в банковской тематике?',
            content: () => (
                <p>
                    Особенности продвижения банковских сайтов включают высокий уровень конкуренции,
                    необходимость строгого соблюдения правовых требований и&nbsp;защиты данных,
                    особое внимание к&nbsp;доверительным и&nbsp;экспертным материалам, а&nbsp;также
                    необходимость локального SEO для привлечения клиентов из&nbsp;конкретных
                    регионов.
                </p>
            ),
        },
        {
            title: 'Какие ошибки на сайте могут негативно сказаться на продвижении банка?\n',
            content: () => (
                <p>
                    Ошибки, влияющие на&nbsp;продвижение банковских сайтов, включают медленную
                    загрузку страниц, отсутствие адаптации для мобильных устройств, нехватку
                    качественного контента, нарушение требований безопасности
                    и&nbsp;конфиденциальности, а&nbsp;также неэффективную внутреннюю структуру
                    и&nbsp;плохую навигацию.
                </p>
            ),
        },
        {
            title: 'Какие метрики используются для оценки эффективности SEO продвижения банковского сайта?',
            content: () => (
                <p>
                    Основные метрики для оценки эффективности SEO продвижения включают органический
                    трафик, позиции ключевых слов в&nbsp;поисковой выдаче, показатель отказов,
                    среднее время на&nbsp;сайте, количество просмотренных страниц за&nbsp;сеанс,
                    конверсию целевых действий (например, заполнение заявок или регистрация),
                    а&nbsp;также количество и&nbsp;качество обратных ссылок. Эти метрики помогают
                    отслеживать прогресс и&nbsp;корректировать стратегию продвижения при
                    необходимости.
                </p>
            ),
        },
    ],
    korporativ: [
        {
            icon: '/images/svg/promotion/1.svg',
            title: 'Разработка стратегии продвижения',
            content: () => (
                <p>
                    Разработка стратегии начинается с&nbsp;анализа конкурентов и&nbsp;целевой
                    аудитории. Определяются ключевые запросы, разрабатываются тактики улучшения
                    видимости сайта, устанавливаются цели и&nbsp;KPI. Стратегия продвижения
                    формируется на&nbsp;основе детального анализа рынка и&nbsp;особенностей бизнеса.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/2.svg',
            title: 'Настройка систем аналитики',
            content: () => (
                <p>
                    Системы аналитики позволяют отслеживать поведение пользователей на&nbsp;сайте
                    и&nbsp;оценивать эффективность SEO продвижения. Устанавливаются
                    и&nbsp;настраиваются инструменты Google Analytics, Яндекс.Метрика и&nbsp;другие
                    системы аналитики для мониторинга трафика и&nbsp;пользовательских действий.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/3.svg',
            title: 'Сбор семантических запросов',
            content: () => (
                <p>
                    Сбор запросов включает анализ и&nbsp;подбор ключевых слов, которые наиболее
                    релевантны для продвигаемого сайта. При подборе формируется семантическое ядро,
                    которое служит основой для дальнейшей оптимизации контента и&nbsp;расширения
                    структуры сайта, улучшения его видимости в&nbsp;поисковых системах.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/4.svg',
            title: 'Технический аудит сайта',
            content: () => (
                <p>
                    Аудит сайта проводится для выявления ошибок и&nbsp;проблем, которые препятствуют
                    эффективному SEO продвижению. Проверяются скорость загрузки сайта, мобильная
                    адаптация, правильность индексации, наличие дублирующегося контента и&nbsp;иные
                    технические моменты. Результаты аудита используются для устранения ошибок.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/1.svg',
            title: 'Формирование и&nbsp;расширение структуры сайта',
            content: () => (
                <p>
                    Данный вид работ направлен на&nbsp;создание удобной и&nbsp;логичной иерархии
                    страниц. Оптимизируется архитектура сайта, создаются новые разделы
                    и&nbsp;страницы, улучшается внутреннее перелинкование. Это помогает
                    пользователям ориентироваться на&nbsp;сайте, а&nbsp;поисковым системам легче
                    находить и&nbsp;индексировать контент.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/5.svg',
            title: 'Оптимизация контента',
            content: () => (
                <p>
                    Включает редактирование контента на&nbsp;существующих страницах и&nbsp;создание
                    нового с&nbsp;учётом семантического ядра. Важно обеспечить уникальность,
                    информативность и&nbsp;релевантность контента для пользователей и&nbsp;поисковых
                    систем. Оптимизируются заголовки, мета теги, изображения и&nbsp;иные элементы.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/1.svg',
            title: 'Проработка внешней ссылочной массы',
            content: () => (
                <p>
                    Направлена на&nbsp;увеличение числа качественных внешних ссылок на&nbsp;сайт.
                    Проводится работа по&nbsp;размещению ссылок на&nbsp;авторитетных ресурсах,
                    а&nbsp;также создание контента, которым пользователи будут сами активно
                    делиться. Это улучшает авторитет и&nbsp;позиции сайта в&nbsp;поисковой выдаче.
                </p>
            ),
        },
        {
            icon: '/images/svg/promotion/2.svg',
            title: 'Мониторинг и аналитика',
            content: () => (
                <p>
                    Это непрерывный процесс отслеживания показателей сайта и&nbsp;анализа
                    эффективности SEO мероприятий. Регулярно анализируются данные о&nbsp;трафике,
                    поведении пользователей, позициях в&nbsp;поисковых системах. На&nbsp;основе этой
                    информации корректируется стратегия продвижения.
                </p>
            ),
        },
    ],
    korporativQuestions: [
        {
            title: 'Что включает в себя SEO-стратегия для корпоративных сайтов?',
            content: () => (
                <p>
                    SEO-стратегия для корпоративных сайтов является комплексной и&nbsp;включает
                    в&nbsp;себя техническую оптимизацию (скорость загрузки, мобильная адаптивность,
                    структура сайта), оптимизацию контента (ключевые слова, качество текста,
                    мультимедиа), работу со&nbsp;ссылками (внутренними и&nbsp;внешними), аналитику
                    и&nbsp;отслеживание результатов.
                </p>
            ),
        },
        {
            title: 'Когда я смогу увидеть результаты продвижения корпоративного сайта?',
            content: () => (
                <p>
                    Первые признаки улучшений можно заметить через 3-4 месяца после старта
                    SEO-продвижения, такие, как рост органического трафика, повышение позиций
                    по&nbsp;отдельным ключевым словам и&nbsp;увеличение видимости сайта
                    в&nbsp;поисковой выдаче. Однако для достижения значительных и&nbsp;устойчивых
                    результатов необходимо продолжать работу в&nbsp;течение 6-12 месяцев
                    и&nbsp;более.
                </p>
            ),
        },
        {
            title: 'Какова роль контента в SEO-продвижении корпоративного сайта?\n',
            content: () => (
                <p>
                    Контент играет ключевую роль в&nbsp;SEO-продвижении. Качественный, уникальный
                    и&nbsp;релевантный контент обеспечивает лучший пользовательский опыт, повышает
                    авторитет сайта в&nbsp;глазах поисковых систем и&nbsp;пользователей. Регулярное
                    создание оптимизированного контента с&nbsp;учетом ключевых слов
                    и&nbsp;потребностей целевой аудитории способствует росту органического трафика
                    и&nbsp;конверсии.
                </p>
            ),
        },
        {
            title: 'Какие инструменты используются для SEO анализа и мониторинга корпоративного сайта?',
            content: () => (
                <p>
                    Для анализа и&nbsp;мониторинга корпоративного сайта используются такие
                    инструменты, как Яндекс.Метрика, Яндекс.Вебмастер, Google Analytics, Google
                    Search Console, Ahrefs, SEMrush, и&nbsp;Screaming Frog. Эти инструменты помогают
                    отслеживать позиции ключевых слов, анализировать трафик, выявлять технические
                    проблемы, проверять обратные ссылки и&nbsp;получать ценные инсайты для улучшения
                    стратегии SEO.
                </p>
            ),
        },
        {
            title: 'Какие ошибки следует избегать при SEO продвижении корпоративного сайта?',
            content: () => (
                <p>
                    Основные ошибки, которых следует избегать, включают использование некорректных
                    или нерелевантных ключевых слов, создание низкокачественного или дублированного
                    контента, игнорирование технической оптимизации сайта, отсутствие адаптации для
                    мобильных устройств, покупка некачественных обратных ссылок и&nbsp;игнорирование
                    аналитики и&nbsp;мониторинга результатов.
                </p>
            ),
        },
    ],
    storeQuestions: [
        {
            title: 'Как SEO продвижение может помочь увеличить продажи в моем интернет-магазине?',
            content: () => (
                <p>
                    SEO продвижение помогает увеличить видимость вашего интернет-магазина
                    в&nbsp;поисковых системах, привлекая больше целевых посетителей на&nbsp;сайт.
                    Это, в&nbsp;свою очередь, повышает шансы на&nbsp;конвертацию посетителей
                    в&nbsp;покупателей, что ведет к&nbsp;увеличению продаж.
                </p>
            ),
        },
        {
            title: 'Сколько времени нужно, чтобы увидеть результаты SEO-продвижения сайта?',
            content: () => (
                <p>
                    Результаты SEO-продвижения обычно начинают проявляться через 3-6&nbsp;месяцев.
                    На&nbsp;сроки влияют конкуренция в&nbsp;нише, состояние сайта, качество контента
                    и&nbsp;объем работ. Важно помнить, что SEO&nbsp;&mdash; это долгосрочная
                    стратегия, требующая постоянного улучшения и&nbsp;адаптации.
                </p>
            ),
        },
        {
            title: 'Есть ли разница между продвижением нового сайта и сайта, который давно в поиске?',
            content: () => (
                <p>
                    Да, есть разница. Новый сайт требует больше времени и&nbsp;усилий для завоевания
                    доверия поисковых систем и&nbsp;аудитории. Сайты с&nbsp;историей имеют уже
                    некоторую репутацию и&nbsp;авторитет, что облегчает продвижение, но&nbsp;они
                    могут сталкиваться с&nbsp;устаревшими практиками и&nbsp;необходимостью
                    обновления.
                </p>
            ),
        },
        {
            title: 'От чего зависит стратегия продвижения сайта магазина?',
            content: () => (
                <p>
                    Стратегия продвижения сайта магазина зависит от&nbsp;таких факторов, как
                    конкурентность ниши, целевая аудитория, ассортимент товаров, структура сайта
                    и&nbsp;бюджет. Анализ конкурентов, подбор ключевых слов и&nbsp;создание
                    качественного контента&nbsp;&mdash; основные элементы успешной стратегии.
                </p>
            ),
        },
        {
            title: 'Что входит в стоимость поискового продвижения?',
            content: () => (
                <p>
                    Стоимость поискового продвижения включает анализ сайта и&nbsp;конкурентов,
                    подбор ключевых слов, оптимизацию контента, техническое SEO, работу над
                    ссылочным профилем, отчетность и&nbsp;мониторинг результатов. Цена может
                    варьироваться в&nbsp;зависимости от&nbsp;объема и&nbsp;сложности работ.
                </p>
            ),
        },
    ],
    estateQuestions: [
        {
            title: 'Как провести анализ эффективности продвижения сайта недвижимости?\n',
            content: () => (
                <p>
                    Для анализа эффективности продвижения необходимо отслеживать несколько метрик:
                    посещаемость сайта, источники трафика, поведение пользователей, конверсию лидов
                    и&nbsp;продаж. Важно также проанализировать позиции сайта в&nbsp;поисковой
                    выдаче по&nbsp;целевым запросам. Следует отслеживать динамику изменения этих
                    показателей во&nbsp;времени и&nbsp;сопоставлять их&nbsp;с&nbsp;проводимыми
                    маркетинговыми мероприятиями. Анализ источников трафика поможет оценить
                    эффективность каналов привлечения посетителей, а&nbsp;показатели
                    конверсии&nbsp;&mdash; насколько успешно сайт превращает посетителей
                    в&nbsp;клиентов.
                </p>
            ),
        },
        {
            title: 'Какая информация нужна от клиента для начала работы над проектом?',
            content: () => (
                <p>
                    Для начала работы над проектом продвижения сайта агентства недвижимости
                    необходимо собрать следующую информацию от&nbsp;клиента: общие сведения
                    о&nbsp;компании, её&nbsp;услугах и&nbsp;целевой аудитории, информация
                    о&nbsp;самом сайте, его структуре, контенте и&nbsp;текущем трафике, список
                    ключевых запросов, по&nbsp;которым клиент хочет продвигаться в&nbsp;поиске,
                    бюджет на&nbsp;продвижение и&nbsp;маркетинговые активности, анализ сайтов
                    конкурентов, бизнес-цели продвижения.
                </p>
            ),
        },
        {
            title: 'Как клиент может контролировать эффективность продвижения сайта агентства недвижимости?',
            content: () => (
                <p>
                    Для контроля эффективности продвижения сайта клиенту регулярно направляются
                    отчёты с&nbsp;анализом ключевых показателей: посещаемость, источники трафика,
                    поведение пользователей, позиции в&nbsp;выдаче, конверсия лидов и&nbsp;продаж,
                    а&nbsp;также динамику их&nbsp;изменения. Полезно проводить сравнение плановых
                    и&nbsp;фактических показателей, обсуждать достигнутые результаты и&nbsp;вносить
                    корректировки в&nbsp;стратегию при необходимости. Клиент также может
                    самостоятельно просматривать статистику в&nbsp;системах веб-аналитики, таких,
                    как Google Analytics.
                </p>
            ),
        },
        {
            title: 'Как влияет скорость загрузки сайта на его SEO продвижение?',
            content: () => (
                <p>
                    Скорость загрузки сайта является одним из&nbsp;ключевых факторов ранжирования
                    в&nbsp;поисковых системах. Медленно загружающийся сайт может ухудшить
                    пользовательский опыт и&nbsp;привести к&nbsp;повышению показателя отказов, что
                    негативно сказывается на&nbsp;SEO. Оптимизация изображений, использование
                    кэширования и&nbsp;минимизация кода помогают ускорить загрузку сайта.
                </p>
            ),
        },
        {
            title: 'Какие технические аспекты нужно учитывать при SEO оптимизации корпоративного сайта?',
            content: () => (
                <p>
                    Техническая SEO оптимизация помимо улучшения скорости загрузки сайта, включает
                    в&nbsp;себя улучшение мобильной адаптации, правильную настройку URL-структуры,
                    создание и&nbsp;обновление карты сайта, использование правильных мета-тегов
                    и&nbsp;обеспечение безопасности с&nbsp;помощью SSL-сертификатов.
                </p>
            ),
        },
    ],
    servicesQuestions: [
        {
            title: 'В чем сложность продвижения сайта юристов?',
            content: () => (
                <p>
                    Основная сложность продвижения юридического сайта заключается в&nbsp;высокой
                    конкуренции на&nbsp;этом рынке. Множество юридических фирм
                    и&nbsp;квалифицированных специалистов стремятся занять лидирующие позиции
                    в&nbsp;выдаче, что значительно усложняет задачу. Кроме того, поисковые системы
                    предъявляют строгие требования к&nbsp;качеству и&nbsp;экспертности контента
                    на&nbsp;юридических сайтах, что затрудняет процесс оптимизации.
                </p>
            ),
        },
        {
            title: 'С чего начать SEO-продвижение сайта юридических услуг?',
            content: () => (
                <p>
                    Первым шагом в&nbsp;SEO-продвижении должен стать глубокий анализ целевой
                    аудитории, конкурентов и&nbsp;ключевых запросов. Необходимо определить наиболее
                    перспективные направления для дальнейшей оптимизации. Далее следует
                    оптимизировать структуру сайта, технические параметры и&nbsp;создать
                    качественный, уникальный контент, отвечающий требованиям поисковых систем
                    и&nbsp;интересам целевой аудитории.
                </p>
            ),
        },
        {
            title: 'Как повысить доверие и авторитет сайта юридической фирмы в глазах поисковых систем?',
            content: () => (
                <p>
                    Для повышения доверия и&nbsp;авторитета сайта юридической фирмы необходимо
                    сосредоточиться на&nbsp;создании экспертного контента высокого качества.
                    Публикации должны быть глубокими, информативными и&nbsp;актуальными,
                    демонстрирующими профессионализм авторов. Кроме того, важно наличие качественных
                    внешних ссылок с&nbsp;авторитетных ресурсов, отзывов клиентов и&nbsp;упоминаний
                    в&nbsp;СМИ. Активное участие юристов в&nbsp;профильных сообществах
                    и&nbsp;мероприятиях также может положительно сказаться на&nbsp;авторитете сайта.
                </p>
            ),
        },
        {
            title: 'Как часто нужно обновлять контент на юридическом сайте для эффективного SEO?',
            content: () => (
                <p>
                    Регулярное обновление контента помогает поддерживать актуальность информации
                    и&nbsp;улучшать позиции в&nbsp;поисковых системах. Рекомендуется публиковать
                    новые статьи, новости и&nbsp;обновления как минимум раз в&nbsp;месяц,
                    а&nbsp;также периодически пересматривать и&nbsp;обновлять основные страницы
                    сайта, чтобы информация оставалась актуальной и&nbsp;полезной для пользователей.
                </p>
            ),
        },
        {
            title: 'Какие метрики используются для оценки эффективности SEO продвижения юридического сайта?',
            content: () => (
                <p>
                    Основные метрики для оценки эффективности включают органический трафик, позиции
                    ключевых слов в&nbsp;поисковой выдаче, показатель отказов, среднее время
                    на&nbsp;сайте, количество просмотренных страниц за&nbsp;сеанс, количество лидов
                    и&nbsp;конверсий, а&nbsp;также количество и&nbsp;качество обратных ссылок. Эти
                    метрики помогают отслеживать успех стратегии и&nbsp;корректировать её&nbsp;при
                    необходимости.
                </p>
            ),
        },
    ],
    autoQuestions: [
        {
            title: 'Как SEO продвижение может помочь увеличить продажи на сайте автозапчастей?',
            content: () => (
                <p>
                    SEO продвижение улучшает видимость вашего сайта в&nbsp;поисковых системах,
                    привлекая больше целевых посетителей. Это увеличивает вероятность того, что
                    потенциальные клиенты найдут и&nbsp;приобретут автозапчасти именно у&nbsp;вас.
                </p>
            ),
        },
        {
            title: 'Как улучшить локальное SEO для сайта автозапчастей?',
            content: () => (
                <p>
                    Для улучшения локального SEO необходимо: оптимизировать страницы с&nbsp;учётом
                    местоположения пользователей, создать оптимизированную страницу
                    &laquo;Контакты&raquo; с&nbsp;картой, зарегистрироваться в&nbsp;локальных
                    справочниках, публиковать отзывы с&nbsp;указанием местоположения, создавать
                    контент с&nbsp;упоминанием местных ориентиров.
                </p>
            ),
        },
        {
            title: 'Нужно ли оптимизировать страницы товаров для SEO?',
            content: () => (
                <p>
                    Да, оптимизация страниц товаров важна. Каждая страница должна содержать
                    уникальный, релевантный контент, описания, характеристики, качественные
                    изображения, а&nbsp;также использовать правильные заголовки, мета теги, ссылки
                    и&nbsp;другие элементы On-Page оптимизации. Это повысит видимость страниц
                    в&nbsp;поисковых системах и&nbsp;конверсию.
                </p>
            ),
        },
        {
            title: 'Какие типы контента подходят для продвижения сайта автозапчастей? ',
            content: () => (
                <p>
                    Эффективными типами контента являются: информационные статьи и&nbsp;руководства,
                    обзоры автомобилей и&nbsp;запчастей, видеоконтент (обучающие видео, обзоры),
                    инфографика и&nbsp;иллюстрации, отзывы клиентов. Такой контент привлекает
                    целевую аудиторию и&nbsp;повышает авторитетность сайта в&nbsp;глазах поисковых
                    систем.
                </p>
            ),
        },
        {
            title: 'Как анализ конкурентов помогает в SEO продвижении сайта?',
            content: () => (
                <p>
                    Анализ конкурентов помогает выявить их&nbsp;сильные и&nbsp;слабые стороны, найти
                    новые ключевые слова и&nbsp;стратегии, которые могут быть эффективны для вашего
                    сайта. Это позволяет улучшить вашу собственную SEO стратегию и&nbsp;занять более
                    высокие позиции в&nbsp;поисковой выдаче.
                </p>
            ),
        },
    ],
    dentQuestions: [
        {
            title: 'Как SEO продвижение может помочь увеличить количество пациентов?',
            content: () => (
                <p>
                    SEO продвижение улучшает видимость вашего сайта в&nbsp;поисковых системах, что
                    привлекает больше целевых посетителей. Это увеличивает шансы на&nbsp;запись
                    новых пациентов, которые ищут стоматологические услуги в&nbsp;вашем регионе.
                </p>
            ),
        },
        {
            title: 'Как создать качественный контент для сайта стоматологии?',
            content: () => (
                <p>
                    Создавайте уникальные, полезные и&nbsp;информативные статьи, посвященные
                    различным аспектам стоматологии, процедурам, советам по&nbsp;гигиене полости рта
                    и&nbsp;т.д. Обязательно добавляйте релевантные ключевые слова и&nbsp;фразы,
                    но&nbsp;не&nbsp;переусердствуйте. Используйте структурированный контент
                    с&nbsp;заголовками, списками и&nbsp;изображениями для лучшего восприятия.
                    Регулярно обновляйте контент, чтобы поддерживать актуальность и&nbsp;привлекать
                    новых посетителей.
                </p>
            ),
        },
        {
            title: 'Как измерить эффективность продвижения клиники?',
            content: () => (
                <p>
                    Для оценки эффективности SEO-продвижения стоматологической клиники необходимо
                    отслеживать и&nbsp;анализировать ряд ключевых метрик. Во-первых, следите
                    за&nbsp;изменениями позиций сайта в&nbsp;поисковой выдаче по&nbsp;релевантным
                    запросам. Во-вторых, анализируйте трафик и&nbsp;поведение пользователей
                    на&nbsp;сайте, такие показатели, как количество посетителей, источники трафика,
                    глубина просмотра страниц и&nbsp;время, проведенное на&nbsp;сайте. В-третьих,
                    отслеживайте количество обращений и&nbsp;записей на&nbsp;прием, поступивших
                    через сайт. Сравнивайте эти данные с&nbsp;предыдущими периодами и&nbsp;целями
                    для оценки прогресса.
                </p>
            ),
        },
        {
            title: 'Какие внешние факторы влияют на SEO-продвижение стоматологии?',
            content: () => (
                <p>
                    Существует ряд внешних факторов, которые необходимо учитывать при
                    SEO-продвижении стоматологической клиники. Для начала, конкуренция в&nbsp;этой
                    нише может быть высокой, особенно в&nbsp;крупных городах. Отслеживайте действия
                    конкурентов и&nbsp;адаптируйте свою стратегию соответственно. Также, изменения
                    в&nbsp;алгоритмах поисковых систем могут повлиять на&nbsp;ранжирование сайта.
                    Регулярно следите за&nbsp;обновлениями и&nbsp;корректируйте стратегию.
                </p>
            ),
        },
        {
            title: 'Какие технические аспекты важны для продвижения сайта?',
            content: () => (
                <p>
                    Важные технические аспекты включают оптимизацию скорости загрузки сайта,
                    обеспечение мобильной адаптации, создание удобной навигации, правильную
                    настройку URL-структуры и&nbsp;использование SSL-сертификатов для безопасности.
                </p>
            ),
        },
    ],
    furnitureQuestions: [
        {
            title: 'Как оптимизировать страницы товаров для SEO на сайте магазина мебели?',
            content: () => (
                <p>
                    Оптимизация страниц товаров является основной задачей для SEO интернет-магазина
                    мебели. Необходимо уделить внимание заголовкам страниц, использовать релевантные
                    ключевые слова в&nbsp;URL-адресах, описаниях товаров и&nbsp;заголовках. Важно
                    также добавлять качественные изображения с&nbsp;alt-тегами
                    и&nbsp;структурировать контент с&nbsp;помощью заголовков. Кроме того, следует
                    обеспечить удобную навигацию и&nbsp;быструю загрузку страниц.
                </p>
            ),
        },
        {
            title: 'Какие инструменты могут помочь в SEO-продвижении магазина мебели?',
            content: () => (
                <p>
                    Существует множество полезных инструментов для SEO-продвижения интернет-магазина
                    мебели. Например, Ahrefs, SEMrush, Google Search Console и&nbsp;Яндекс.Вебмастер
                    помогают анализировать ключевые слова и&nbsp;выявлять технические ошибки.
                    Инструменты Screaming Frog и&nbsp;DeepCrawl полезны для сканирования
                    и&nbsp;аудита сайта. Также рекомендуется использовать Яндекс. Метрику
                    и&nbsp;Google Analytics для анализа трафика и&nbsp;поведения пользователей.
                </p>
            ),
        },
        {
            title: 'Какие ключевые слова наиболее эффективны для SEO-продвижения магазина мебели?',
            content: () => (
                <p>
                    При выборе эффективных ключевых слов для SEO-продвижения магазина мебели следует
                    учитывать популярность запросов, актуальность для целевой аудитории,
                    коммерческую составляющую и&nbsp;конкуренцию. Рекомендуется использовать
                    сочетания, включающие названия мебели, материалы, стили, бренды, города или
                    регионы. Например, &laquo;кухонный гарнитур из&nbsp;массива дерева&raquo;,
                    &laquo;детская мебель в&nbsp;Москве&raquo;, &laquo;кожаные диваны
                    в&nbsp;классическом стиле&raquo;. Не&nbsp;стоит забывать о&nbsp;длинных
                    хвостовых запросах.
                </p>
            ),
        },
        {
            title: 'Как локальное SEO помогает мебельным сайтам привлекать клиентов?',
            content: () => (
                <p>
                    Локальное SEO помогает пользователям найти ваш сайт мебельного магазина
                    в&nbsp;конкретном регионе. Это включает использование географических ключевых
                    слов, создание и&nbsp;оптимизацию профилей в&nbsp;Яндекс.Бизнес, Google
                    My&nbsp;Business и&nbsp;других локальных каталогах, а&nbsp;также сбор отзывов
                    клиентов.
                </p>
            ),
        },
        {
            title: 'Как часто нужно обновлять контент на сайте мебели для эффективного SEO?',
            content: () => (
                <p>
                    Регулярное обновление контента помогает поддерживать актуальность информации
                    и&nbsp;улучшать позиции в&nbsp;поисковых системах. Публикуйте новые статьи,
                    обновляйте страницы товаров и&nbsp;делитесь новостями вашего магазина, чтобы
                    информация оставалась полезной для пользователей.
                </p>
            ),
        },
    ],
    newsQuestions: [
        {
            title: 'Какие метрики важны для оценки эффективности SEO-продвижения новостного сайта?',
            content: () => (
                <p>
                    Основные метрики включают органический трафик, позиции ключевых слов, показатель
                    отказов, среднее время на&nbsp;сайте, количество просмотренных страниц
                    за&nbsp;сеанс, а&nbsp;также количество и&nbsp;качество обратных ссылок. Эти
                    показатели помогают отслеживать успех стратегии и&nbsp;вносить необходимые
                    корректировки.
                </p>
            ),
        },
        {
            title: 'Как регулярно обновляемый контент влияет на ранжирование новостного сайта?',
            content: () => (
                <p>
                    Регулярное обновление контента необходимо для поддержания актуальности
                    и&nbsp;релевантности информации. Публикация новых статей несколько раз
                    в&nbsp;день или ежедневно помогает улучшить позиции в&nbsp;поисковых системах
                    и&nbsp;удержать внимание аудитории, что положительно сказывается на&nbsp;SEO.
                </p>
            ),
        },
        {
            title: 'Как использование мультимедийного контента влияет на продвижение сайта новостей?',
            content: () => (
                <p>
                    Использование мультимедийного контента (фото, видео, инфографика и&nbsp;т.д.)
                    оказывает положительное влияние на&nbsp;SEO новостного сайта. Визуальный контент
                    делает материалы более привлекательными и&nbsp;увеличивает вовлеченность
                    аудитории. Изображения с&nbsp;правильными атрибутами alt помогают поисковикам
                    лучше воспринимать контекст страницы. Видео и&nbsp;инфографики снижают
                    показатели отказов, что улучшает поведенческие факторы ранжирования.
                </p>
            ),
        },
        {
            title: 'Какие ключевые слова важны для SEO продвижения новостного сайта?',
            content: () => (
                <p>
                    Важные ключевые слова включают термины, связанные с&nbsp;актуальными событиями,
                    трендами, новостями и&nbsp;темами, интересными вашей аудитории. Использование
                    популярных запросов и&nbsp;долгих хвостов помогает охватить широкий спектр
                    интересов и&nbsp;увеличить органический трафик на&nbsp;сайт.
                </p>
            ),
        },
        {
            title: 'Как внутренняя перелинковка влияет SEO новостного сайта?',
            content: () => (
                <p>
                    Внутренняя перелинковка улучшает навигацию по&nbsp;сайту, помогает распределить
                    вес ключевых слов и&nbsp;увеличивает время, которое пользователи проводят
                    на&nbsp;сайте. Это улучшает SEO показатели, поскольку поисковые системы
                    оценивают структурированность и&nbsp;связность контента на&nbsp;сайте.
                </p>
            ),
        },
    ],
    productsQuestions: [
        {
            title: 'Как выбрать ключевые слова для SEO-продвижения сайта завода?',
            content: () => (
                <p>
                    Начните с&nbsp;определения целевой аудитории и&nbsp;понимания поисковых
                    запросов, которые могут использовать для поиска продукции/услуг завода.
                    Проанализируйте популярные ключевые слова в&nbsp;этой отрасли с&nbsp;помощью
                    инструментов Яндекс.Wordstat, SEMrush или Ahrefs. Выберите высокочастотные,
                    связанные с&nbsp;бизнесом ключевые слова с&nbsp;умеренной конкуренцией. Включите
                    и&nbsp;долгохвостные ключевики для привлечения целевого трафика.
                </p>
            ),
        },
        {
            title:
                'Какие метрики следует отслеживать для оценки эффективности' +
                ' SEO продвижения производственного сайта?',
            content: () => (
                <p>
                    Основные метрики включают органический трафик, позиции ключевых слов, показатель
                    отказов, среднее время на&nbsp;сайте, количество просмотренных страниц
                    за&nbsp;сеанс, а&nbsp;также количество и&nbsp;качество обратных ссылок. Эти
                    показатели помогают отслеживать успех стратегии и&nbsp;вносить необходимые
                    корректировки.
                </p>
            ),
        },
        {
            title: 'Какие внешние факторы влияют на SEO-продвижение сайта производства?',
            content: () => (
                <p>
                    Внешние факторы включают авторитетность и&nbsp;популярность сайта, качество
                    обратных ссылок, поведение пользователей. Авторитетность повышается при наличии
                    качественных ссылок с&nbsp;высокоавторитетных сайтов отрасли. Популярность
                    отражает востребованность контента, что измеряется временем на&nbsp;сайте,
                    показателем отказов и&nbsp;другими метриками. Поведенческие факторы, такие как
                    процент отказов, время на&nbsp;сайте, отражают привлекательность контента.
                </p>
            ),
        },
        {
            title: 'Как локальное SEO может помочь производственному сайту?',
            content: () => (
                <p>
                    Локальное SEO оптимизирует ваш сайт для поиска производственных услуг
                    в&nbsp;конкретных регионах. Использование географических ключевых слов, создание
                    локализованного контента и&nbsp;оптимизация профилей в&nbsp;Яндекс.Бизнес
                    и&nbsp;Google My&nbsp;Business привлекают местных клиентов, улучшая позиции
                    в&nbsp;локальной поисковой выдаче.
                </p>
            ),
        },
        {
            title: 'Как использовать техническую оптимизацию для улучшения SEO сайта завода? ',
            content: () => (
                <p>
                    Оптимизируйте скорость загрузки страниц, чтобы обеспечить хороший
                    пользовательский опыт. Настройте файл robots.txt для управления индексацией
                    страниц. Создайте XML-карту сайта для упрощения поиска контента поисковиками.
                    Оптимизируйте заголовки страницы, мета описания, alt-теги изображений
                    с&nbsp;ключевыми словами. Обеспечьте удобную для навигации структуру сайта.
                    Исправьте ошибки 404 и&nbsp;дубликаты контента. Внедрите SSL-сертификат для
                    повышения безопасности. Поддерживайте доступность сайта для мобильных устройств.
                </p>
            ),
        },
    ],
};
